import { http } from '@/lib/axios';
import { unwrap, toApiError } from '@/lib/unwrap';
import type { ApiEnvelope } from '@/types/api';
import type { PaymentMethod } from '@/types/payment';

export async function getPaymentMethods(): Promise<PaymentMethod[]> {
  try {
    const res = await http.get<ApiEnvelope<PaymentMethod[]>>('/payment-method');
    const data = unwrap(res.data);
    return Array.isArray(data) ? data : [];
  } catch (error) {
    throw toApiError(error);
  }
}
